<template>
    <div class="nrk">
        <ul class="systemzs">
            <li>
                <img src="img/zx-2.jpg">
                <p>环 境 管 理 体 系  : 执行GB/T24001－2016/ISO14001 : 2015标准</p>
            </li>
            <li>
                <img src="img/zx-3.jpg">
                <p>质 量 体 管 理 体 系  : 执行GB/T19001－2016/ISO9001 : 2015标准</p>
            </li>
            <li>
                <img src="img/zx-4.jpg">
                <p>职业健康安全管理体系    : 执行GB/T45001－2020/ISO45001 : 2018标准</p>
            </li>
        </ul>
        <div class="Servic nrk">
            <p>管理方针</p>
            <img src="img/beij_3.jpg" class="beij">
            <img src="img/beij_4.jpg" class="beijn">
        </div>
        <div class="Servic nrk lisn">
            <p>管理方针</p>
            <span>项目投资合理，工程方案优化，设计技术先进，</span>
            <span>产品符合标准，提供全程服务，达到顾客满意，</span>
            <span>产品符合标准，提供全程服务，达到顾客满意，</span>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .beij{
        margin-top: 20px;
    }
    .beijn{
        display: none;
    }
    .systemzs{
        width: 100%;
        overflow: hidden;
        margin: 26px auto;
    }
    .systemzs li{
        width: 33%;
        float: left;
        text-align: center;
    }
    .systemzs li img{
        width: 58%;
        margin-bottom: 12px;
    }
    .lisn span{
        color: #2d3c56;
        line-height: 70px;
        display: block;
        font-size: 20px;
    }
    .beijn{
        width: 100%;
    }
     @media (max-width: 768px){
        .systemzs li{
            width: 100%;
        }
        .beij{
            display: none;
        }
        .beijn{
            display: block;
        }
        .systemzs li p{
            margin-bottom: 20px;
        }
        .lisn span{
            font-size: 16px;
            line-height: 50px;
        }
     }
</style>
